/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ActivityTypeEnum } from '../models/ActivityTypeEnum';
import { Actor } from '../models/Actor';
import { CustomTrainingSession } from '../models/CustomTrainingSession';
import { HorseActivityLocation } from '../models/HorseActivityLocation';
import { HorseActivityPhoto } from '../models/HorseActivityPhoto';
import { HorseActivityReactionSummary } from '../models/HorseActivityReactionSummary';
import { HorseActivityVideo } from '../models/HorseActivityVideo';
import { Medical } from '../models/Medical';
import { Shoeing } from '../models/Shoeing';
import { SimpleGroup } from '../models/SimpleGroup';
import { SimpleHorse } from '../models/SimpleHorse';
import { SimpleUser } from '../models/SimpleUser';
import { TrainingSession } from '../models/TrainingSession';
import { VisibilityEnum } from '../models/VisibilityEnum';
import { HttpFile } from '../http/http';

export class HorseActivity {
    'id': number;
    'dtCreated': Date;
    'dtModified': Date;
    'dtPerformed': Date;
    'isDraft'?: boolean;
    'type': ActivityTypeEnum;
    'horse'?: SimpleHorse;
    'actor'?: Actor;
    'creator'?: SimpleUser;
    'data'?: { [key: string]: any; };
    'location'?: HorseActivityLocation;
    'title'?: string;
    'text'?: string;
    'trainingSession'?: TrainingSession;
    'customTrainingSession'?: CustomTrainingSession;
    'shoeing'?: Shoeing;
    'medical'?: Medical;
    'photos': Array<HorseActivityPhoto>;
    'videos': Array<HorseActivityVideo>;
    'reactionSummary': HorseActivityReactionSummary;
    'commentCount': number;
    'visibility'?: VisibilityEnum;
    'isPlanned'?: boolean;
    'hasFinishedPlanned'?: boolean;
    'plannedWithTime'?: boolean;
    'group'?: SimpleGroup;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "dtCreated",
            "baseName": "dtCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "dtModified",
            "baseName": "dtModified",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "dtPerformed",
            "baseName": "dtPerformed",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "isDraft",
            "baseName": "isDraft",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "ActivityTypeEnum",
            "format": ""
        },
        {
            "name": "horse",
            "baseName": "horse",
            "type": "SimpleHorse",
            "format": ""
        },
        {
            "name": "actor",
            "baseName": "actor",
            "type": "Actor",
            "format": ""
        },
        {
            "name": "creator",
            "baseName": "creator",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "data",
            "baseName": "data",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "HorseActivityLocation",
            "format": ""
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        },
        {
            "name": "trainingSession",
            "baseName": "trainingSession",
            "type": "TrainingSession",
            "format": ""
        },
        {
            "name": "customTrainingSession",
            "baseName": "customTrainingSession",
            "type": "CustomTrainingSession",
            "format": ""
        },
        {
            "name": "shoeing",
            "baseName": "shoeing",
            "type": "Shoeing",
            "format": ""
        },
        {
            "name": "medical",
            "baseName": "medical",
            "type": "Medical",
            "format": ""
        },
        {
            "name": "photos",
            "baseName": "photos",
            "type": "Array<HorseActivityPhoto>",
            "format": ""
        },
        {
            "name": "videos",
            "baseName": "videos",
            "type": "Array<HorseActivityVideo>",
            "format": ""
        },
        {
            "name": "reactionSummary",
            "baseName": "reactionSummary",
            "type": "HorseActivityReactionSummary",
            "format": ""
        },
        {
            "name": "commentCount",
            "baseName": "commentCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "visibility",
            "baseName": "visibility",
            "type": "VisibilityEnum",
            "format": ""
        },
        {
            "name": "isPlanned",
            "baseName": "isPlanned",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasFinishedPlanned",
            "baseName": "hasFinishedPlanned",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "plannedWithTime",
            "baseName": "plannedWithTime",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "group",
            "baseName": "group",
            "type": "SimpleGroup",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return HorseActivity.attributeTypeMap;
    }

    public constructor() {
    }
}



